import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ENVIRONMENT, Environment } from "../../../core/auth/auth.tokens";
import { DataList, Meter, PaginatedResult, Sensor, SensorsFiltersPage, VisualizationGroup } from "libs/domain";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SensorService { 

  private http = inject(HttpClient);
  private options: Environment = inject(ENVIRONMENT);
  private baseUrl;

  constructor() {
    this.baseUrl = `${this.options.baseUrl.data}`;
  }

  getSensors(tenantId: string, page: number, size: number, filters?: SensorsFiltersPage): Observable<PaginatedResult<Sensor>> {
    const body = {
      page: page,
      size: size,
      ...filters
    };
    return this.http.post<PaginatedResult<Sensor>>(`${this.baseUrl}/communities/${tenantId}/sensors`, body);
  }
  
  getMeterSensor(tenantId: string, meterId: number) {
    return this.http.get<Meter>(`${this.baseUrl}/communities/${tenantId}/meters/${meterId}`);
  }

  getSensorsVisualizationGroups(tenantId: string){
    return this.http.get<DataList<VisualizationGroup>>(`${this.baseUrl}/communities/${tenantId}/sensors/visualization-groups`);
  }
}